import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { useSelector } from 'react-redux'

const AvatarPlaceholder = (props: SvgIconProps) => {
  const themeMode = useSelector(selectTheme)

  return (
    <SvgIcon role="img" viewBox="0 0 29 29" {...props}>
      <circle cx="14.5" cy="14.5" r="14.5" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7.83337C13.8034 7.83337 12.8334 8.80342 12.8334 10C12.8334 11.1967 13.8034 12.1667 15 12.1667C16.1967 12.1667 17.1667 11.1967 17.1667 10C17.1667 8.80342 16.1967 7.83337 15 7.83337ZM11.8334 10C11.8334 8.25114 13.2511 6.83337 15 6.83337C16.7489 6.83337 18.1667 8.25114 18.1667 10C18.1667 11.7489 16.7489 13.1667 15 13.1667C13.2511 13.1667 11.8334 11.7489 11.8334 10Z"
        fill={themeMode === mode_type.dark ? '#004744 ' : '#fff'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 20.6666C8.5 17.0768 11.4102 14.1666 15 14.1666C18.5898 14.1666 21.5 17.0768 21.5 20.6666C21.5 20.9428 21.2761 21.1666 21 21.1666C20.7239 21.1666 20.5 20.9428 20.5 20.6666C20.5 17.6291 18.0376 15.1666 15 15.1666C11.9624 15.1666 9.5 17.6291 9.5 20.6666C9.5 20.9428 9.27614 21.1666 9 21.1666C8.72386 21.1666 8.5 20.9428 8.5 20.6666Z"
        fill={themeMode === mode_type.dark ? '#004744 ' : '#fff'}
      />
    </SvgIcon>
  )
}

export default AvatarPlaceholder
